import { Typography } from "@mui/material";
import { useIntl } from "react-intl";
import { PAGE_STATUS } from "../constants";

export default function SharedChatWindowHeader({
  dir,
  status,
  title,
  createdLabel,
}) {
  const intl = useIntl();

  return (
    <div className="shared-chat-window-header">
      <div className="shared-chat-window-header-main">
        <Typography component="h1" className="shared-chat-window-title">
          {status === PAGE_STATUS.SUCCESS
            ? title
            : intl.formatMessage({
                id: "chatbot.sharedPageTitle",
                defaultMessage:
                  dir === "rtl" ? "محادثة مشتركة" : "Shared chat",
              })}
        </Typography>
        {status === PAGE_STATUS.SUCCESS && createdLabel && (
          <Typography className="shared-chat-window-date">
            {intl.formatMessage(
              {
                id: "chatbot.sharedCreatedAt",
                defaultMessage:
                  dir === "rtl"
                    ? "تاريخ المشاركة: {date}"
                    : "Shared on {date}",
              },
              { date: createdLabel },
            )}
          </Typography>
        )}
      </div>
      <div className="shared-chat-window-accent" aria-hidden />
    </div>
  );
}
